import { isMobile } from 'react-device-detect';
import * as React from 'react';
import { CcIcon } from '@utp/components-react';
import { Block, Heading, Text } from '@/presentation/components';
import { InteractiveButton } from '@/presentation/modules/procedures/components';
import { Disclaimer } from '../styled';

interface ModalDisclamerProps {
  handleClick: () => void;
}
const ModalDisclamer: React.FC<ModalDisclamerProps> = (props) => {
  const { handleClick } = props;
  return (
    <>
      <Block
        customized
        maxWidth={isMobile ? '100%' : '496px'}
        backgroundColor="#fff"
        padding="0px 32px 32px 32px"
        margin="8px 0px 0px 0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Heading
          text={'¿Qué son los créditos presenciales y virtuales?'}
          level={2}
          color="#161D1F"
          size={20}
          lineHeight={32}
          fontWeight="900"
          className=""
          align="center"
          width="100%"
        />
        <p
          style={{
            marginTop: 12
          }}
        >
          Según el Artículo 34 del Reglamento de Estudios vigente: El estudiante
          se gradúa al culminar su plan de estudios en la modalidad
          correspondiente, conforme al porcentaje de créditos virtuales y
          presenciales aprobados, dentro de los márgenes que establece la
          normativa vigente.
        </p>
        <p
          style={{
            marginTop: 12
          }}
        >
          Dependiendo de la modalidad de estudios te corresponderá cumplir:
        </p>
        <ul
          style={{
            padding: 12,
            listStyle: 'initial'
          }}
        >
          <li>
            <b>P (Presencial): </b> Hasta 20% de créditos virtuales.
          </li>
          <li>
            <b>SP (Semipresencial): </b> Desde 21% hasta 70% de créditos
            virtuales.
          </li>
          <li>
            <b>D (A distancia): </b> Desde 71% hasta 80% de créditos virtuales.
          </li>
        </ul>
        <Disclaimer>
          <div>
            <CcIcon size={16} name={'alert-circle'} />
            <p>
              Ten en cuenta que para mantener tu modalidad de estudios no debes
              exceder los porcentajes indicados.
            </p>
          </div>
        </Disclaimer>
        <InteractiveButton
          data-testid="handle-SAE"
          bkgColorEnabled="#5B36F2"
          bkgColorHover="#745EF6"
          bkgColorFocus="#4318CD"
          bkgColorPressed="#4318CD"
          customized
          as="button"
          alignItems="center"
          backgroundColor="#5B36F2"
          padding="10px 16px"
          borderRadius="4px"
          margin="40px 0px 0px 0px"
          width={isMobile ? '100%' : '180px'}
          onClick={() => handleClick()}
        >
          <Text
            color="#FFFFFF"
            fontSize="14px"
            lineHeight="20px"
            fontWeight="400"
            textAlign="center"
          >
            Entendido{' '}
          </Text>
        </InteractiveButton>
      </Block>
    </>
  );
};

export default ModalDisclamer;
